// Identidad visual del board. La LISTA de repos ya NO es fija: se descubre en
// vivo con useRepos() (queries.ts) desde /user/repos. Este módulo solo define la
// shape `Repo` + overrides de nombre/color para los repos conocidos; los repos
// nuevos caen a una paleta automática por hash del slug.
import type { RepoInfo } from './github'

export interface Repo {
  slug: string // owner/repo (full_name de GitHub)
  name: string
  color: string
}

const DISPLAY: Record<string, { name: string; color: string }> = {
  'wipxap/wipxap-fitlab':    { name: 'FITLAB',       color: 'text-red-400' },
  'wipxap/CEMSA':            { name: 'CEMSA',        color: 'text-blue-400' },
  'wipxap/kunamasta':        { name: 'Kunamasta',    color: 'text-fuchsia-400' },
  'wipxap/TITANIUM':         { name: 'TITANIUM',     color: 'text-cyan-400' },
  'wipxap/cea-by-incluyeme': { name: 'CEA',          color: 'text-emerald-400' },
  'wipxap/ict-spa':          { name: 'ICT-SPA',      color: 'text-orange-400' },
  'wipxap/cemsa-activa':     { name: 'CEMSA ACTIVA', color: 'text-teal-300' },
}

const PALETTE = [
  'text-sky-400', 'text-lime-400', 'text-violet-400', 'text-pink-400',
  'text-amber-400', 'text-indigo-400', 'text-rose-400', 'text-green-400',
]

function hash(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  return Math.abs(h)
}

export function toRepo(info: RepoInfo): Repo {
  const o = DISPLAY[info.full_name]
  return {
    slug: info.full_name,
    name: o?.name ?? info.name,
    color: o?.color ?? PALETTE[hash(info.full_name) % PALETTE.length],
  }
}
